var exports = {
  "kL": "ScopeSheet.module__container___dUotWG",
  "XG": "ScopeSheet.module__scroller___dUotWG",
  "iy": "ScopeSheet.module__optionsContainer___dUotWG",
  "uK": "ScopeSheet.module__option___dUotWG",
  "h4": "ScopeSheet.module__optionSelected___dUotWG",
  "ts": "ScopeSheet.module__optionLeft___dUotWG",
  "H9": "ScopeSheet.module__optionIcon___dUotWG",
  "AJ": "ScopeSheet.module__optionIconSelected___dUotWG",
  "re": "ScopeSheet.module__optionText___dUotWG",
  "ed": "ScopeSheet.module__optionLabel___dUotWG",
  "tD": "ScopeSheet.module__optionLabelSelected___dUotWG",
  "q3": "ScopeSheet.module__optionDescription___dUotWG",
  "oE": "ScopeSheet.module__checkIcon___dUotWG",
};

module.exports = exports;
